function OffscreenIndicators({ left, right }) {
  return (
    <>
      {left && (
        <div className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/70 text-white text-xs px-2 py-1 rounded-full">
          🌱
        </div>
      )}

      {right && (
        <div className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/70 text-white text-xs px-2 py-1 rounded-full">
          🌱
        </div>
      )}
    </>
  )
}

export default OffscreenIndicators
